<template>
  <StudentViewComponents :callFrom="'all'"/>
</template>

<script>
import StudentViewComponents from '@/components/students/StudentViewComponents.vue';
</script>
